import { Helmet } from "react-helmet-async"
import { AutomationSchedulesList } from "../../../../../Automations"

export default function OrganizationAutomationSchedulesPage() {
	return (
		<>
			<Helmet>
				<title>Automation Schedules</title>
			</Helmet>
			<AutomationSchedulesList />
		</>
	)
}
